import { render, staticRenderFns } from "./newStaff.vue?vue&type=template&id=15a5a989&"
import script from "./newStaff.vue?vue&type=script&lang=js&"
export * from "./newStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports